import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Box } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { useState } from 'react';
import Typography from '@mui/material/node/Typography';
import { db } from '../../config/firebase';
import { useNavigate } from 'react-router-dom';
import { addDoc, collection } from 'firebase/firestore';
import { StyleLine, StyleShape, TypeLine } from '../../types';
import { ElementData } from '../../data/elementData';
import { ProjectData } from '../../data/projectData';

export const NewProjectDialog = (props) => {
  const [projectDetails, setProjectDetails] = useState({
    name: "",
    description: ""
  });
  const [createButtonText, setCreateButtonText] = useState("Create");
  const [createButtonIsDisabled, setCreateButtonIsDisabled] = useState(false);
  const navigate = useNavigate();

  const handleConfirm = async (event) => {
    event.preventDefault();
    if (!event.target[0].validity.valid) {
      event.target[0].focus();
      return;
    }
    if (!projectDetails.name || projectDetails.name.trim() === "") {
      event.target[0].focus();
      return;
    }

    setCreateButtonIsDisabled(true);
    setCreateButtonText("Wait");

    let newData = ElementData;
    newData.id  = 1;
    newData.name = "asd";

    let data = ProjectData;

    data = {
      name: projectDetails.name,
      description: projectDetails.description,
      owner: props.uid,
      createdon: new Date().toISOString(),
      elements: [
        {
          data: {
            ...newData
          },
          group: "nodes"
        }
      ]
    };

    console.log(data);

    try {
      const newCityRef = collection(db, 'project');
      const res = await addDoc(newCityRef, data);

      navigate(`/project/${res.id}`);
    } catch (e) {
      console.log(e);
    }

    setCreateButtonIsDisabled(false);
    setCreateButtonText("Create");

    props.handleClose();
    //props.refreshLayout();
  }

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setProjectDetails((prev) => {
      return { ...prev, [name]: value }
    });
  };

  return (
    <div>
      <Dialog open={props.open} onClose={props.handleClose}>
        <DialogTitle>New project</DialogTitle>
        <Box
          component="form"
          autoComplete="off"
          onSubmit={handleConfirm}
          noValidate
        >
          <DialogContent>
            <DialogContentText>
              <TextField size="small" required autoFocus margin="dense" name="name" label="Name" type="text" fullWidth onChange={handleChange} />
              <TextField size="small" margin="dense" name="description" label="Description" multiline rows={4} type="text" fullWidth onChange={handleChange} />
              {props.type === 2 && <Typography>You're creating project without registration. Only way to access it is with this URL. Copy it and save. Project of this type will be automatically deteled after 30 days of last access.</Typography>}
              {props.type === 2 && <TextField size="small" margin="dense" name="url" label="URL" type="text" fullWidth />}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={props.handleClose} disabled={createButtonIsDisabled} variant="contained" color="error" startIcon={<CancelIcon />}>Cancel</Button>
            <Button type='submit' disabled={createButtonIsDisabled} variant="contained" color="success">{createButtonText}</Button>
          </DialogActions>
        </Box>
      </Dialog>
    </div>
  );
}


